import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import ItemAttachmentModel from '../../../models/ItemAttachmentModel';
import ItemRevisionModel from '../../../models/ItemRevisionModel';
import DataService from "../../../services/data.service";
import Attachment_popup_ReviseAttachment from '../../Common/Popups/Attachment_popup_ReviseAttachment';
import AddItemAttachmentPopup from '../Popups/ItemRevision_popup_AddAttachment';

const ItemRevision_tab_Attachments: React.FC<ItemRevisionModel> = (itemRevision) => {
    const [data, setData] = useState<ItemAttachmentModel[]>();
    const [selectedAttachmentId, setSelectedAttachmentId] = useState<number>()
    const [showAddPopup, setShowAddPopup] = useState<boolean>(false)
    const [showRevisePopup, setShowRevisePopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedForAttachmentType } = useAuth();

    useEffect(() => {
        getTableData();
    }, [itemRevision.id]);

    function getTableData() {
        DataService.get<ItemAttachmentModel[]>('api/v1/ItemAttachments/ByItemRevision/' + itemRevision.id)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData: ItemAttachmentModel) {
        DataService.delete('api/v1/ItemAttachments/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    function downloadAttachment(rowData: ItemAttachmentModel) {
        if (rowData.attachmentLatestVersion.fileUrl) {
            const link = document.createElement('a');
            link.href = rowData.attachmentLatestVersion.fileUrl;
            link.download = rowData.attachmentLatestVersion.fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    function viewAttachment(rowData: ItemAttachmentModel) {
        if (rowData.attachmentLatestVersion.fileUrl) {
            const link = document.createElement('a');

            link.href = rowData.attachmentLatestVersion.fileUrl;
            link.target = '_blank';
            if (rowData.attachmentLatestVersion.fileName.endsWith('.ai'))
                link.download = rowData.attachmentLatestVersion.fileName.replace('.ai', '.pdf');

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    function reviseAttachment(rowData: ItemAttachmentModel) {
        setSelectedAttachmentId(rowData.attachment.id)
        setShowRevisePopup(true)
    }

    function canDeleteRow(row): boolean {
        if (row.attachment.attachmentType.canDelete && isAuthorizedForAttachmentType(ApplicationFunctions.DeleteAttachment, row.attachment.attachmentTypeId))
            return true

        return false;
    }

    function canCreateAttachment(): boolean {
        if (isAuthorizedForAttachmentType(ApplicationFunctions.CreateAttachment))
            return true

        return false;
    }

    return (
        <>
            <DataTable
                name='dtItemRevisionAttachments'
                tableData={data}
                navigateTitle='Attachment'
                navigateUrl='/plm/Common/Attachment/'
                colInfos={[
                    { key: true, dataProp: 'attachmentId', visible: false },
                    { dataProp: 'attachment.thumbnailUrl', dataType: 'bigimage', sort:false },
                    { title: 'Type', dataProp: 'attachment.attachmentType.name', filterInfo: { filterType: 'CheckboxList' } },
                    { title: 'Name', dataProp: 'attachment.name', sort: 'asc', filterInfo: { filterType: 'Textbox' } },
                    { title: 'Version', dataProp: 'attachment.latestVersion', dataType: 'number', width: 100, filterInfo: { filterType: 'CheckboxList' } },
                    { title: 'Created on', dataProp: 'attachmentLatestVersion.createdOn', dataType: 'datetime' },
                    { title: 'Created by', dataProp: 'attachmentLatestVersion.createdByUser', dataType: 'user', filterInfo: { filterType: 'CheckboxList' } },
                    {
                        width: 70,
                        sort: false,
                        rowButtons: [
                            { text: "Download", icon: 'fa-cloud-download', color: 'rgb(137, 196, 244)', onClick: downloadAttachment },
                            { text: "View", icon: 'fa-eye', color: 'rgb(137, 196, 244)', onClick: viewAttachment },
                            { text: "Revise", icon: 'fa-edit', color: 'rgb(137, 196, 244)', onClick: reviseAttachment }
                        ]
                    },
                    {
                        headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => {getTableData(); setShowAddPopup(true)}, isVisible: canCreateAttachment }],
                        rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow, isVisible: canDeleteRow }]
                    }
                ]}

            />
            {showAddPopup && data && <AddItemAttachmentPopup itemRevision={itemRevision} itemAttachments={data} show={showAddPopup} onHide={() => { setShowAddPopup(false); getTableData(); }} />}
            {showRevisePopup && selectedAttachmentId&&  <Attachment_popup_ReviseAttachment attachmentId={selectedAttachmentId} show={showRevisePopup} onHide={() => { setShowRevisePopup(false); getTableData(); }} />}
        </>
    );
}
export default ItemRevision_tab_Attachments;